import { createError, defineNuxtRouteMiddleware } from '#imports'

import { useBuybackEnabled } from '../composables/useBuybackEnabled/useBuybackEnabled'

export default defineNuxtRouteMiddleware(() => {
  const { isBuybackEnabled } = useBuybackEnabled()

  if (!isBuybackEnabled) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Buyback is not enabled for this market',
      fatal: true,
    })
  }
})
